import React from 'react'

import { Calendar } from 'primereact/calendar'
import { InputNumber } from 'primereact/inputnumber'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'

import {
  RequiredTrackedValueString1,
  TrackedValueString,
  TrackedValueString1,
} from '../../../../../../../data/models/_generatedUblInvoice'
import { ConfigurableComponent } from '../../../../../../../utils/wrapper'
import { ValueStatus } from '../../../../../common/value-status'

type FieldType = 'text' | 'date' | 'number' | 'textarea'

type SummaryFieldProps = {
  id: string
  label: string
  value: string | number | Date | null | undefined
  trackedValue?:
    | TrackedValueString
    | TrackedValueString1
    | RequiredTrackedValueString1
  type?: FieldType
  config: any
  className?: string
  locale?: string
  currency?: string
  rows?: number
}

export const SummaryField: React.FC<SummaryFieldProps> = ({
  id,
  label,
  value,
  trackedValue,
  type = 'text',
  config,
  className = 'col-12 md:col-6 lg:col-4',
  locale = 'en',
  currency = 'EUR',
  rows = 3,
}) => {
  const labelComponent = <label htmlFor={id}>{label}</label>

  const renderInputComponent = () => {
    switch (type) {
      case 'date':
        return (
          <Calendar
            id={id}
            value={value instanceof Date ? value : undefined}
            className="w-full"
            locale={locale}
            disabled
          />
        )
      case 'number':
        return (
          <InputNumber
            id={id}
            value={typeof value === 'number' ? value : undefined}
            className="w-full"
            minFractionDigits={2}
            mode="currency"
            currency={currency}
            locale={locale}
            disabled
          />
        )
      case 'textarea':
        return (
          <InputTextarea
            id={id}
            value={typeof value === 'string' ? value : undefined}
            className="w-full"
            rows={rows}
            disabled
          />
        )
      case 'text':
      default:
        return (
          <InputText
            id={id}
            value={typeof value === 'string' ? value : undefined}
            className="w-full"
            disabled
          />
        )
    }
  }

  return (
    <ConfigurableComponent
      config={config}
      label={labelComponent}
      component={
        <>
          {renderInputComponent()}
          <div className="mt-2">
            <ValueStatus trackedValue={trackedValue} />
          </div>
        </>
      }
      className={className}
    />
  )
}
